export enum TipoAcesso {
    ACESSO_RESTRITO = <any> "Acesso Restrito",
    ACESSO_TOTAL = <any> "Acesso Total"
}



// WEBPACK FOOTER //
// ./src/app/util/enum/tipo-acesso.enum.ts